import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import cpfValidate from '@vr/devkit/validators/cpfValidate';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { DateField, MaskField } from '../../../elements';
import getErrorMsg from '../../../helpers/errorMessages';
import { Title } from '../../common';
import { VRPAT } from '~/config/constants';

const Content = styled.div`
  display: block;
  text-align: center;

  ${({ color }) => css`
    input {
      color: ${color} !important;
      border-bottom-color: ${color} !important;
    }
    label {
      color: ${color} !important;
      font-size: 15px !important;
    }
    .MuiInput-underline::before,
    .MuiInput-underline::after {
      border-color: ${color} !important;
    }
    .MuiIconButton-root {
      display: none;
    }
    .MuiInputBase-input {
      caret-color: ${color} !important;
      -webkit-text-fill-color: ${color} !important;
    }
  `}
`;
const CardContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 30px;
  margin-bottom: 45px;
`;

export default function ForgotCardPassword({ errors, formControl, trigger }) {
  const issuer = useSelector(state => state?.issuer?.name);
  const color = issuer === VRPAT ? 'white' : 'black';

  return (
    <Content color={color}>
      <Title marginBottom="26px">Informe seus dados</Title>
      <MaskField
        ariaLabel="CPF"
        fullWidth
        label="Seu CPF *"
        name="cpf"
        mask="999.999.999-99"
        type="tel"
        executeActionOnBlur={() => trigger('cpf')}
        rules={{
          required: true,
          minLength: 14,
          validate: val => {
            return cpfValidate(val);
          },
        }}
        formControl={formControl}
        error={!!errors?.cpf}
        caption={getErrorMsg(errors, 'cpf')}
        style={{
          marginBottom: '20px',
        }}
      />
      <MaskField
        ariaLabel="número do cartão"
        label="Número do cartão *"
        fullWidth
        name="cardNumberChangingPassword"
        mask="9999  9999  9999  9999"
        type="tel"
        rules={{
          required: true,
          minLength: 22, // 22 e não 16 pois precisa contar os espaços da mask
          validate: val => val.length === 22,
        }}
        formControl={formControl}
        error={!!errors.cardNumberChangingPassword}
        caption={getErrorMsg(errors, 'cardNumberChangingPassword')}
        style={{
          marginBottom: '20px',
        }}
      />
      <CardContainer>
        <DateField
          ariaLabel="data de validade"
          fullWidth
          label="Data de validade *"
          name="dueDate"
          type="date"
          format="MM/yy"
          rules={{
            required: true,
            validate: val => {
              const date = moment(val, 'MM/yy', true);
              return date.isValid();
            },
          }}
          formControl={formControl}
          error={!!errors?.dueDate}
          caption={getErrorMsg(errors, 'dueDate')}
        />
        <MaskField
          ariaLabel="cvv"
          label="CVV *"
          fullWidth
          name="cvv"
          mask="999"
          type="tel"
          rules={{
            required: true,
            minLength: 3,
          }}
          formControl={formControl}
          error={!!errors.cvv}
          caption={getErrorMsg(errors, 'cvv')}
          style={{
            maxWidth: '80px',
          }}
        />
      </CardContainer>
    </Content>
  );
}

ForgotCardPassword.propTypes = {
  errors: PropTypes.object,
  formControl: PropTypes.object.isRequired,
  trigger: PropTypes.func,
};
